import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  useRoutes,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { publicRoutes, routes } from "../../routes/routes";
import Layout from "../Home";

const App = () => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.authReducer);
  const content = useRoutes(publicRoutes);

  useEffect(() => {
    if (window.location.pathname === "/") {
      navigate("/slider", { replace: true });
    }
  }, []);

  return (
    <>
      {token ? (
        <Routes>
          <Route path="/" key={"layoutKey"} element={<Layout />}>
            {routes.map((item, idx) => (
              <Route
                path={item.path}
                key={`${idx + 1}`}
                index={item?.index}
                element={item.element}
              />
            ))}
            <Route path="*" element={<Navigate to="/slider" replace />} />
          </Route>
        </Routes>
      ) : (
        content
      )}
    </>
  );
};

export default App;
